// UUIDv7 (RFC 9562): 48-bit Unix-millisecond timestamp, version nibble 7, 12 bits of
// sub-millisecond counter/randomness, variant bits, 62 random bits. Time-ordered, so
// event ids sort by creation and index locally (D9-2). Monotonic within a process:
// ids generated in the same millisecond increase strictly via the 12-bit counter.
let lastMs = -1;
let counter = 0;
function randomBytes(n) {
    const out = new Uint8Array(n);
    globalThis.crypto.getRandomValues(out);
    return out;
}
export function uuidv7(now = Date.now()) {
    let ms = now;
    if (ms <= lastMs) {
        // Same (or earlier, clock went backwards) millisecond: advance the counter;
        // if it overflows, borrow a millisecond so ordering is preserved.
        counter += 1;
        if (counter > 0x0fff) {
            counter = 0;
            lastMs += 1;
        }
        ms = lastMs;
    }
    else {
        lastMs = ms;
        counter = randomBytes(2)[0] & 0x07ff; // start low so there is room to count
    }
    const b = new Uint8Array(16);
    b[0] = (ms / 2 ** 40) & 0xff;
    b[1] = (ms / 2 ** 32) & 0xff;
    b[2] = (ms / 2 ** 24) & 0xff;
    b[3] = (ms / 2 ** 16) & 0xff;
    b[4] = (ms / 2 ** 8) & 0xff;
    b[5] = ms & 0xff;
    b[6] = 0x70 | ((counter >> 8) & 0x0f); // version 7 + high 4 bits of counter
    b[7] = counter & 0xff;
    const r = randomBytes(8);
    b[8] = 0x80 | (r[0] & 0x3f); // variant 10
    for (let i = 1; i < 8; i++)
        b[8 + i] = r[i];
    const hex = Array.from(b, (x) => x.toString(16).padStart(2, "0")).join("");
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export function isUuid(value) {
    return UUID_RE.test(value);
}
/** Milliseconds since epoch encoded in a UUIDv7, or null for other versions. */
export function uuidv7Time(id) {
    if (!isUuid(id) || id[14] !== "7")
        return null;
    const hex = id.replace(/-/g, "").slice(0, 12);
    return Number.parseInt(hex, 16);
}
//# sourceMappingURL=ids.js.map